// extracted by mini-css-extract-plugin
module.exports = {"bannerDiv":"Banner_bannerDiv__340I9","bannerText":"Banner_bannerText__3x4wz"};